import React from 'react'
import { useMediaSize, Space, TextBody } from '@ally/metronome-ui'
import { getFirstName } from '@ally/data-selectors-afg-customer'
import { useHostServices } from '../HostServices'
import { formatDate } from '../utils'

const Greeting: React.FC = () => {
  const { hostData, session } = useHostServices()
  const firstName = getFirstName(hostData)
  const isSmDown = useMediaSize('SmDown')
  const lastLoginTimeStamp = session.data?.lastLoginTime

  return (
    <>
      {firstName ? (
        <Space mt="xs" mb="sm">
          <TextBody tag="p" size="md" data-private>
            Hello {firstName}
            {lastLoginTimeStamp && !isSmDown && (
              <>
                {' '}
                &bull; Last Login{' '}
                {formatDate(lastLoginTimeStamp, 'MMM DD, YYYY')} &bull;{' '}
                {formatDate(lastLoginTimeStamp, 'h:mm A')} ET
              </>
            )}
          </TextBody>
        </Space>
      ) : null}
    </>
  )
}

export default Greeting
